"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "marcignago": {
    "c011141c": [{
      "hkey": "da3a4972",
      "slug": "marcignago",
      "name": "Marcignago",
      "primary": true,
      "skipSearch": false
    }],
    "colombarola": [{
      "hkey": "da3a4972",
      "slug": "marcignago",
      "name": "Marcignago",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "72140d79": [{
      "hkey": "da3a4972",
      "slug": "marcignago",
      "name": "Marcignago",
      "primary": true,
      "skipSearch": false
    }],
    "montagnola": [{
      "hkey": "da3a4972",
      "slug": "marcignago",
      "name": "Marcignago",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c87c4611": [{
      "hkey": "ef270821",
      "slug": "molino-vecchio",
      "name": "Molino Vecchio",
      "primary": true,
      "skipSearch": false
    }],
    "mulino-vecchio": [{
      "hkey": "ef270821",
      "slug": "molino-vecchio",
      "name": "Molino Vecchio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "beb42825": [{
      "hkey": "da3a4972",
      "slug": "marcignago",
      "name": "Marcignago",
      "primary": true,
      "skipSearch": false
    }],
    "remondo": [{
      "hkey": "da3a4972",
      "slug": "marcignago",
      "name": "Marcignago",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;